<template>
  <v-dialog v-model="navigation.privacyWarningDialogIsVisible" max-width="85vw" persistent>
    <v-card max-width="85vw" style="padding: 20px; text-align: center; cursor: default; user-select: none;">
      <div style="font-family: Arial, sans-serif; color: #333; line-height: 1.6; text-align: left;">

        <h2 style="text-align: center;">
          Aviso de privacidad y monitoreo de actividad
        </h2>
        <br>
        <v-divider thickness="2" color="indigo"></v-divider>
        <br>
        <p>
          Este equipo y los servicios utilizados en él son propiedad o se encuentran
          bajo la administración de nuestra organización. Con el objetivo de proteger la
          información, los sistemas y los recursos de nuestra organización, así como
          garantizar el uso adecuado de los equipos durante la jornada laboral,
          <strong>la actividad realizada desde este dispositivo puede ser monitoreada,
          registrada y/o auditada.</strong>
        </p>
        <p>El monitoreo puede incluir, entre otros:</p>
        <br>
        <ul style="margin-left: 20px;">
          <li>
            La actividad realizada dentro de los sistemas y aplicaciones de nuestra
            organización.
          </li>
          <li>
            Los sitios web visitados desde este equipo.
          </li>
          <li>
            La navegación realizada mediante navegadores web.
          </li>
          <li>
            Intentos de acceder a sitios, servicios o recursos no autorizados.
          </li>
          <li>
            Instalación, ejecución o utilización de aplicaciones y extensiones.
          </li>
          <li>
            Información técnica relacionada con el dispositivo, la conexión y el uso
            de los recursos corporativos.
          </li>
        </ul>
        <br>
        <p>
          La información recopilada podrá ser utilizada exclusivamente para fines
          relacionados con <strong>seguridad, protección de la información,
          administración de los equipos, prevención de usos indebidos, cumplimiento
          de las políticas internas y supervisión del uso de los recursos
          corporativos.</strong>
        </p>
        <br>
        <p>
          El acceso a sitios web o servicios no autorizados puede estar restringido.
          Asimismo, determinadas actividades pueden ser registradas automáticamente
          por los mecanismos de seguridad y administración implementados en el
          dispositivo.
        </p>
        <br>
        <p>
          <strong>
            Al utilizar este equipo, usted reconoce que ha sido informado de la
            existencia de estos mecanismos de monitoreo y que el uso del dispositivo
            está sujeto a las políticas y condiciones establecidas por nuestra
            organización.
          </strong>
        </p>
        <p>
          Si considera que necesita acceder a un sitio o servicio que actualmente se
          encuentra restringido por razones laborales, deberá solicitar autorización
          al personal responsable.
        </p>
        <br>
        <v-divider thickness="2" color="indigo"></v-divider>
        <br>
        <v-checkbox-btn
          v-model="input.privacyWarningRead"
          color="indigo"
          label="He leído el aviso y estoy de acuerdo"
        >
        </v-checkbox-btn>
        <br>
        <v-btn
          @click="closePrivacyWarningDialog()"
          :disabled="input.privacyWarningRead == false"
          color="indigo"
          block
          class="hoverableVButton"
        >
          <v-icon dark start>mdi-check-circle</v-icon>
          <h3>CONTINUAR</h3>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>


  export default
  {
    data: () => 
    ({
      input: 
      {
        privacyWarningRead: false
      },
      navigation: 
      {
        privacyWarningDialogIsVisible: false
      }
    }),

    methods:
    {
      openPrivacyWarningDialog(){
        this.navigation.privacyWarningDialogIsVisible = true;
      },

      closePrivacyWarningDialog(){
        localStorage.setItem('privacyWarning', 'true');
        this.navigation.privacyWarningDialogIsVisible = false;
      }
    }
  }
</script>